import React from 'react';
import classNames from 'classnames';

const X_PADDING = 'px-4 sm:px-6';

type CardProps = {
  children: React.ReactNode;
};

function Card({ children }: CardProps): JSX.Element {
  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      {children}
    </div>
  );
}

type HeaderProps = {
  title: string;
  subtitle?: string;
};

function CardHeader({ title, subtitle }: HeaderProps): JSX.Element {
  const headerClass = classNames(X_PADDING, 'py-5');
  return (
    <div className={headerClass}>
      <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>
      {subtitle ? (
        <p className="mt-1 max-w-2xl text-sm text-gray-500">{subtitle}</p>
      ) : null}
    </div>
  );
}

CardHeader.defaultProps = {
  subtitle: undefined
};

type BodyProps = {
  children: React.ReactNode;
  pad?: boolean;
};

function CardBody({ children, pad }: BodyProps): JSX.Element {
  const bodyClass = classNames(
    pad && X_PADDING,
    pad && 'py-5',
    'border-t border-gray-200'
  );
  return <div className={bodyClass}>{children}</div>;
}

CardBody.defaultProps = {
  pad: true
};

type FooterProps = {
  children: React.ReactNode;
};

function CardFooter({ children }: FooterProps): JSX.Element {
  const footerClass = classNames(X_PADDING, 'py-3 bg-gray-50 text-right');
  return <div className={footerClass}>{children}</div>;
}

export default Card;
export { CardHeader, CardBody, CardFooter };
